import { render, staticRenderFns } from "./ConsultComplaiont.vue?vue&type=template&id=662c8835&scoped=true&"
import script from "./ConsultComplaiont.vue?vue&type=script&lang=js&"
export * from "./ConsultComplaiont.vue?vue&type=script&lang=js&"
import style0 from "./ConsultComplaiont.vue?vue&type=style&index=0&id=662c8835&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662c8835",
  null
  
)

export default component.exports